var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "main" } },
    [
      _c("project-navigation", [
        _c("li", [_c("label", [_vm._v("Projects:")])]),
        _vm._v(" "),
        _c("li", [
          _c("a", { staticClass: "active", attrs: { href: "#" } }, [
            _vm._v("SweetModal for Vue.js")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "http://sweet-modal.adepto.as/" } }, [
            _vm._v("SweetModal for jQuery")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "http://sweet-dropdown.adepto.as/" } }, [
            _vm._v("SweetDropdown for jQuery")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("header", [
        _c("div", { staticClass: "meta" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "action" }, [
            _c(
              "a",
              {
                attrs: { href: "https://github.com/adeptoas/sweet-modal-vue" }
              },
              [
                _vm._v("\n\t\t\t\t\t\tView on\n\n\t\t\t\t\t\t"),
                _c("span", { staticClass: "github" }, [
                  _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z"
                      }
                    })
                  ]),
                  _vm._v("\n\n\t\t\t\t\t\t\tGitHub\n\t\t\t\t\t\t")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-decoration" }),
      _vm._v(" "),
      _c(
        "content-section",
        { staticClass: "examples", attrs: { title: "Examples" } },
        [
          _c("p", { staticClass: "grey" }, [
            _vm._v("\n\t\t\t\tPlease note that "),
            _c("code", [_vm._v("<sweet-button>")]),
            _vm._v(
              " is an implementation\n\t\t\t\tspecific to these examples."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t\tYou need to implement your own buttons for use with SweetModal.\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Alerts")]),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Regular Alert",
                code: _vm.examples.regularAlert,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("regularAlert")
                }
              }
            },
            [
              _c("sweet-modal", { ref: "regularAlert" }, [
                _vm._v("\n\t\t\t\t\tThis is an alert.\n\t\t\t\t\t")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Success Alert",
                code: _vm.examples.successAlert,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("successAlert")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "successAlert", attrs: { icon: "success" } },
                [_vm._v("\n\t\t\t\t\tThis is a success!\n\t\t\t\t\t")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Warning Alert",
                code: _vm.examples.warningAlert,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("warningAlert")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "warningAlert", attrs: { icon: "warning" } },
                [_vm._v("\n\t\t\t\t\tThis is a warning!\n\t\t\t\t")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Alert with Error and Button",
                code: _vm.examples.errorAndButtonAlert,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("errorAndButtonAlert")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                {
                  ref: "errorAndButtonAlert",
                  attrs: { icon: "error", title: "Oh noes…" }
                },
                [
                  _vm._v("\n\t\t\t\t\tThis is an error…\n\n\t\t\t\t\t"),
                  _c(
                    "sweet-button",
                    { attrs: { slot: "button" }, slot: "button" },
                    [_vm._v("That's fine!")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Dark with Blocking Error",
                code: _vm.examples.darkWithBlockingError,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("darkWithBlockingError")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                {
                  ref: "darkWithBlockingError",
                  attrs: {
                    icon: "error",
                    "hide-close-button": "",
                    blocking: "",
                    "overlay-theme": "dark",
                    "modal-theme": "dark"
                  }
                },
                [
                  _vm._v("\n\t\t\t\t\tThis is an error…\n\n\t\t\t\t\t"),
                  _c(
                    "sweet-button",
                    {
                      attrs: { slot: "button", color: "red" },
                      on: {
                        click: function($event) {
                          _vm.closeExample("darkWithBlockingError")
                        }
                      },
                      slot: "button"
                    },
                    [_vm._v("Press this Button")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Dark with HTML Content",
                code: _vm.examples.darkWithHTMLContent,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("darkWithHTMLContent")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                {
                  ref: "darkWithHTMLContent",
                  attrs: { "modal-theme": "dark", "overlay-theme": "dark" }
                },
                [
                  _vm._v("\n\t\t\t\t\tThis is "),
                  _c("b", [_vm._v("HTML")]),
                  _vm._v("-"),
                  _c("i", [_vm._v("Content")]),
                  _vm._v(".\n\t\t\t\t\t"),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("iframe", {
                    attrs: {
                      width: "560",
                      height: "315",
                      src: "https://www.youtube.com/embed/4xgx4k83zzc",
                      frameborder: "0",
                      allowfullscreen: ""
                    }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Additional Window Controls",
                code: _vm.examples.additionalWindowControls,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("additionalWindowControls")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "additionalWindowControls", attrs: { title: "Alert" } },
                [
                  _vm._v("\n\t\t\t\t\tThis is an alert.\n\n\t\t\t\t\t"),
                  _c(
                    "template",
                    { attrs: { slot: "box-action" }, slot: "box-action" },
                    [
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Action 1")]),
                      _vm._v("  \n\t\t\t\t\t\t"),
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Action 2")])
                    ]
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("h3", [_vm._v("Tabbed Content")]),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Tabbed Modal",
                code: _vm.examples.tabbedModal,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("tabbedModal")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "tabbedModal" },
                [
                  _c(
                    "sweet-modal-tab",
                    { attrs: { title: "Tab 1", id: "tab1" } },
                    [_vm._v("Contents of Tab 1")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    { attrs: { title: "Tab 2", id: "tab2" } },
                    [_vm._v("Contents of Tab 2")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    { attrs: { title: "Tab 3", id: "tab3", disabled: "" } },
                    [_vm._v("Tab 3 is disabled")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Tabbed Modal with Icons",
                code: _vm.examples.tabbedModalWithIcons,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("tabbedModalWithIcons")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "tabbedModalWithIcons" },
                [
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 1",
                        id: "tab1",
                        icon: _vm.icons.hexagon
                      }
                    },
                    [_vm._v("Contents of Tab 1")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 2",
                        id: "tab2",
                        icon: _vm.icons.flower
                      }
                    },
                    [_vm._v("Contents of Tab 2")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 3",
                        id: "tab3",
                        icon: _vm.icons.compare,
                        disabled: ""
                      }
                    },
                    [_vm._v("Tab 3 is disabled")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Tabbed Modal with Title",
                code: _vm.examples.tabbedModalWithTitle,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("tabbedModalWithTitle")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                {
                  ref: "tabbedModalWithTitle",
                  attrs: { title: "This is a Tabbed Modal" }
                },
                [
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 1",
                        id: "tab1",
                        icon: _vm.icons.hexagon
                      }
                    },
                    [_vm._v("Contents of Tab 1")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 2",
                        id: "tab2",
                        icon: _vm.icons.flower
                      }
                    },
                    [_vm._v("Contents of Tab 2")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 3",
                        id: "tab3",
                        icon: _vm.icons.compare,
                        disabled: ""
                      }
                    },
                    [_vm._v("Tab 3 is disabled")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Tabbed Modal with Icons and Buttons",
                code: _vm.examples.tabbedModalWithIconsAndButtons,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("tabbedModalWithIconsAndButtons")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "tabbedModalWithIconsAndButtons" },
                [
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 1",
                        id: "tab1",
                        icon: _vm.icons.hexagon
                      }
                    },
                    [_vm._v("Contents of Tab 1")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 2",
                        id: "tab2",
                        icon: _vm.icons.flower
                      }
                    },
                    [_vm._v("Contents of Tab 2")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal-tab",
                    {
                      attrs: {
                        title: "Tab 3",
                        id: "tab3",
                        icon: _vm.icons.compare,
                        disabled: ""
                      }
                    },
                    [_vm._v("Tab 3 is disabled")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-button",
                    {
                      attrs: { slot: "button", color: "light-grey" },
                      slot: "button"
                    },
                    [_vm._v("Action 2")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-button",
                    { attrs: { slot: "button" }, slot: "button" },
                    [_vm._v("Action 1")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Nested",
                code: _vm.examples.nested,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("nested")
                }
              }
            },
            [
              _c(
                "sweet-modal",
                { ref: "nested" },
                [
                  _vm._v("\n\t\t\t\t\tThis is the parent modal.\n\n\t\t\t\t\t"),
                  _c(
                    "sweet-button",
                    {
                      attrs: { slot: "button" },
                      on: {
                        click: function($event) {
                          _vm.$refs.nestedChild.open()
                        }
                      },
                      slot: "button"
                    },
                    [_vm._v("Open Child Modal")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("sweet-modal", { ref: "nestedChild" }, [
                _vm._v("\n\t\t\t\t\tThis is the child modal.\n\t\t\t\t")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "example",
            {
              attrs: {
                "action-title": "Very Long Modal",
                code: _vm.examples.longModal,
                language: "xml"
              },
              on: {
                action: function($event) {
                  _vm.openExample("longModal")
                }
              }
            },
            [
              _c("sweet-modal", { ref: "longModal" }, [
                _vm._v(
                  "\n\t\t\t\t\tLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\n\n\t\t\t\t\tDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. \n\n\t\t\t\t\tUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.\n\n\t\t\t\t\tNam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n\n\t\t\t\t\tDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.\n\n\t\t\t\t\tAt vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.\n\n\t\t\t\t\tConsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus.\n\n\t\t\t\t\tLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\n\n\t\t\t\t\tDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.\n\n\t\t\t\t\tUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.\n\n\t\t\t\t\tNam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n\n\t\t\t\t\tDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.\n\t\t\t\t"
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "content-section",
        { staticClass: "install", attrs: { title: "Install" } },
        [
          _c("p", { staticClass: "grey" }, [
            _c("b", [_vm._v("Note:")]),
            _vm._v(" This is a library solely for use with Vue.js.\n\t\t\t")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v("\n\t\t\t\t\tInstall sweet-modal-vue using npm: "),
              _c("code", [_vm._v("npm install sweet-modal-vue")])
            ]),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v(
                  "\n\t\t\t\t\tImport sweet-modal-vue into your component:"
                ),
                _c("br"),
                _vm._v(" "),
                _c("sweet-code", { attrs: { light: "" } }, [
                  _c("code", { staticClass: "javascript" }, [
                    _vm._v(
                      "import { SweetModal, SweetModalTab } from 'sweet-modal-vue'"
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v(
                  "\n\t\t\t\t\tTell Vue that your component uses SweetModal:"
                ),
                _c("br"),
                _vm._v(" "),
                _c("sweet-code", { attrs: { light: "" } }, [
                  _c("code", { staticClass: "javascript" }, [
                    _vm._v(
                      "{\n\tcomponents: {\n\t\tSweetModal,\n\t\tSweetModalTab\n\t}\n\n\t...\n}"
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n\t\t\t\t\tCreate your modal using one of the examples above.\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v("\n\t\t\t\t\tGive your modal a ref, i.e. "),
                _c("sweet-code", { attrs: { inline: "", light: "" } }, [
                  _c("code", { attrs: { language: "xml" } }, [
                    _vm._v('ref="modal"')
                  ])
                ]),
                _vm._v(".\n\t\t\t\t")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v("\n\t\t\t\t\tOpen your modal by calling "),
                _c("sweet-code", { attrs: { inline: "", light: "" } }, [
                  _c("code", { attrs: { language: "javascript" } }, [
                    _vm._v("this.$refs.modal.open()")
                  ])
                ]),
                _vm._v("."),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\tIf your modal has tabs and you want to open a specific tab, supply the tab's ID as the first argument:\n\t\t\t\t\t"
                ),
                _c("sweet-code", { attrs: { inline: "", light: "" } }, [
                  _c("code", { attrs: { language: "javascript" } }, [
                    _vm._v("this.$refs.modal.open('tab1')")
                  ])
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "content-section",
        {
          staticClass: "attributes",
          attrs: { title: "Attributes: SweetModal" }
        },
        [
          _c("table", { staticClass: "doc" }, [
            _c("tr", [
              _c("th", [_vm._v("Name")]),
              _vm._v(" "),
              _c("th", [_vm._v("Type")]),
              _vm._v(" "),
              _c("th", [_vm._v("Default")]),
              _vm._v(" "),
              _c("th", [_vm._v("Description")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("title")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("null")]),
              _vm._v(" "),
              _c("td", [_vm._v("Title of the modal, shown at the top")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("blocking")]),
              _vm._v(" "),
              _c("td", [_vm._v("Boolean")]),
              _vm._v(" "),
              _c("td", [_vm._v("false")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "If true, user cannot close the modal by clicking on the overlay."
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("pulse-on-block")]),
              _vm._v(" "),
              _c("td", [_vm._v("Boolean")]),
              _vm._v(" "),
              _c("td", [_vm._v("true")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "If false, disabled pulse effect when user clicks outside a blocking modal."
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("icon")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("null")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n\t\t\t\t\t\tAnimated icon to show upon opening the modal. One of these values:"
                ),
                _c("br"),
                _vm._v("\n\t\t\t\t\t\t- success"),
                _c("br"),
                _vm._v("\n\t\t\t\t\t\t- info"),
                _c("br"),
                _vm._v("\n\t\t\t\t\t\t- warning"),
                _c("br"),
                _vm._v("\n\t\t\t\t\t\t- error"),
                _c("br")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("hide-close-button")]),
              _vm._v(" "),
              _c("td", [_vm._v("Boolean")]),
              _vm._v(" "),
              _c("td", [_vm._v("false")]),
              _vm._v(" "),
              _c("td", [_vm._v("If true, close button is hidden.")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("overlay-theme")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("light")]),
              _vm._v(" "),
              _c("td", [_vm._v("Theme of the overlay; light or dark.")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("modal-theme")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("light")]),
              _vm._v(" "),
              _c("td", [_vm._v("Theme of the modal; light or dark.")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "content-section",
        { staticClass: "slots", attrs: { title: "Slots: SweetModal" } },
        [
          _c("table", { staticClass: "doc" }, [
            _c("tr", [
              _c("th", [_vm._v("Name")]),
              _vm._v(" "),
              _c("th", [_vm._v("Description")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("box-action")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("An action to be displayed next to the close button.")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("title")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "Title of the modal, if not given via the title attribute."
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("button")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("Button or Action to be displayed underneath the modal.")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("default")]),
              _vm._v(" "),
              _c("td", [_vm._v("Content of the Modal.")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "content-section",
        { staticClass: "events", attrs: { title: "Events: SweetModal" } },
        [
          _c("table", { staticClass: "doc" }, [
            _c("tr", [
              _c("th", [_vm._v("Name")]),
              _vm._v(" "),
              _c("th", [_vm._v("Description")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("open")]),
              _vm._v(" "),
              _c("td", [_vm._v("When the modal is being opened.")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("close")]),
              _vm._v(" "),
              _c("td", [_vm._v("When the modal is being closed.")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "content-section",
        {
          staticClass: "attributes",
          attrs: { title: "Attributes: SweetModalTab" }
        },
        [
          _c("table", { staticClass: "doc" }, [
            _c("tr", [
              _c("th", [_vm._v("Name")]),
              _vm._v(" "),
              _c("th", [_vm._v("Type")]),
              _vm._v(" "),
              _c("th", [_vm._v("Default")]),
              _vm._v(" "),
              _c("th", [_vm._v("Description")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("id*")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("–")]),
              _vm._v(" "),
              _c("td", [_vm._v("ID of the tab, required")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("title*")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("–")]),
              _vm._v(" "),
              _c("td", [_vm._v("Title displayed in the navigation, required")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("icon")]),
              _vm._v(" "),
              _c("td", [_vm._v("String")]),
              _vm._v(" "),
              _c("td", [_vm._v("null")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n\t\t\t\t\t\tAn SVG string of an icon to be displayed in the navigation."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\t\tAll fills will be overridden so make sure to use a mono-color icon.\n\t\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("disabled")]),
              _vm._v(" "),
              _c("td", [_vm._v("Boolean")]),
              _vm._v(" "),
              _c("td", [_vm._v("false")]),
              _vm._v(" "),
              _c("td", [_vm._v("If true, user cannot navigate to this tab.")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("content-section", { attrs: { title: "License & Copyright" } }, [
        _c("pre", [
          _vm._v(
            "<!--\n\tSweetModal for Vue.js\n\tSweet, easy and powerful modals and dialogs\n\n\tCopyright (c) " +
              _vm._s(_vm.year) +
              " Adepto.as AS · Oslo, Norway\n\tDual licensed under the MIT and GPL licenses.\n\n\tSee LICENSE-MIT.txt and LICENSE-GPL.txt\n-->"
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer", [
        _c("div", { staticClass: "copyright" }, [
          _vm._v("\n\t\t\t\t© " + _vm._s(_vm.year) + " "),
          _c("img", {
            attrs: {
              src:
                "https://assets.adepto.as/images/adepto/branding/logo_grey.svg"
            }
          }),
          _vm._v(
            "  \n\t\t\t\tThis plugin is dual-licensed under the MIT- and GPLv2-licenses."
          ),
          _c("br"),
          _vm._v("\n\t\t\t\tFor help, visit "),
          _c(
            "a",
            {
              attrs: {
                href: "https://github.com/adeptoas/sweet-modal-vue/issues"
              }
            },
            [_vm._v("the issues section")]
          ),
          _vm._v(" of this repository.\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "links" }, [
          _c("a", { attrs: { href: "https://github.com/adeptoas" } }, [
            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
              _c("path", {
                attrs: {
                  d:
                    "M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z"
                }
              })
            ]),
            _vm._v("\n\n\t\t\t\t\tGitHub\n\t\t\t\t")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { staticClass: "main", attrs: { src: "images/logo.svg" } }),
      _vm._v(" "),
      _c("img", { staticClass: "for", attrs: { src: "images/for-vue.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pitch" }, [
      _c("h2", [
        _vm._v("\n\t\t\t\t\tThe sweetest library to happen to modals."),
        _c("br"),
        _vm._v("\n\t\t\t\t\tNow available for Vue.js.\n\t\t\t\t")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b21ccc6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b21ccc6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./docs/views/Main.vue
// module id = 233
// module chunks = 0